import React from "react";
import useCreateJob from "../hooks/useCreateJob";

function Toolbar({ error }) {
  const { createJob, jobCreateError, jobCreating } = useCreateJob();
  const types = [
    ["syllabus", "Sync Syllabus"],
    ["courses/publish", "Publish Courses"],
    ["accounts", "Export Accounts"],
    ["courses", "Export Courses"],
    ["students", "Export Students"],
    ["teachers", "Export Teachers"],
    ["assistants", "Export Assistants"],
    ["terms", "Export Terms"],
    ["users", "Export Users"],
    ["courses/shortnames", "Export Course Shortnames"],
    ["courses/migrate-content", "Migrate Course Content"]
    // ["withdrawal", "Course Withdrawal Student"]
  ];

  return (
    <>
      <div className="toolbar">
        {types.map(([name, label]) => (
          <button
            onClick={() => createJob(name)}
            key={name}
            disabled={jobCreating}
          >
            {label}
          </button>
        ))}
      </div>
      <div style={{ height: 32 }}>
        <span style={{ color: "red" }}>
          {error && "Load Jobs Error: " + error}
          {" | "}
          {jobCreateError && "Create Job Error: " + jobCreateError}
        </span>
        {" | "}
        <span>{jobCreating && "Creating new job"}</span>
      </div>
    </>
  );
}

export default Toolbar;
